module.exports = __webpack_public_path__ + "static/img/rank_299.cb5c2c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_299.png
// module id = cY2k
// module chunks = 1